/**
 * Slim entry point for the customer-facing storefront (components.app-layout).
 *
 * The full `app.js` bundle also ships admin-only tooling (trix, qz-tray,
 * bootstrap, glide, lodash) and Sentry Session Replay — none of which the
 * storefront uses. Shipping that to mobile shoppers dominated Total Blocking
 * Time. This entry loads only what customer pages actually need: Swiper (product
 * / lookbook sliders) and the Livewire scrollTop listener. Alpine ships with
 * Livewire, and Swiper's CSS is already in resources/css/app.css.
 */

import Swiper from 'swiper';
import { Pagination, Zoom, Scrollbar } from 'swiper/modules';

window.Swiper = Swiper;
window.Swiper_Pagination = Pagination;
window.Swiper_Zoom = Zoom;
window.Swiper_Scrollbar = Scrollbar;

document.addEventListener('livewire:init', () => {
    Livewire.on('scrollTop', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});

/**
 * Load Sentry lazily, after the page is interactive and during idle time, so its
 * parse/execute cost falls outside the Total Blocking Time window. Session Replay
 * is intentionally omitted here — it is the heaviest part of the SDK and is not
 * needed on the storefront.
 */
window.addEventListener('load', () => {
    const boot = () => import('./sentry-lite').then((m) => m.initSentry());

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(boot, { timeout: 3000 });
    } else {
        window.setTimeout(boot, 2000);
    }
});
